import { FunnelConfig } from '~/utils/funnels';

export const config: FunnelConfig = {
  id: 'membership',
  path: '/membership',
  show: () => true,
};
